import React, { useId, useState } from 'react';
import { Circle, GoogleMap, InfoWindow, Marker } from '@react-google-maps/api';
import { ILocation, MapProps } from '../../types';
import { PhoneIcon } from '../../icons';
import styles from './styles.module.scss';

// const containerStyle = {
//   width: '100%',
//   height: '100vh'
// };

export const Map: React.FC<MapProps> = ({ locations, radius, center }) => {
  const [selectedLocation, setSelectedLocation] = useState<ILocation | null>(null);

  const id = useId();

  return (
    <GoogleMap mapContainerClassName={styles.mapContainer} center={center} zoom={8}>
      {/* Circle to indicate the radius */}
      <Circle
        center={center}
        radius={radius}
        options={{ fillColor: '#cce7ff', strokeColor: '#0044cc' }}
      />

      {/* Markers */}
      {locations.map((location) => (
        <Marker
          key={location.coordinates.place_id + id}
          position={location.coordinates}
          title={location.title}
          onClick={() => setSelectedLocation(location)}
        />
      ))}

      {/* InfoWindow */}
      {selectedLocation && (
        <InfoWindow
          position={selectedLocation.coordinates}
          onCloseClick={() => setSelectedLocation(null)}>
          <div className={styles.marker}>
            <img alt={selectedLocation.title} src={selectedLocation.imageUrl} />
            <h3>{selectedLocation.title}</h3>
            {selectedLocation.phoneNumber && (
              <p>
                <PhoneIcon width={18} height={18} />
                <a href={`tel:${selectedLocation.phoneNumber}`} rel="noreferrer">
                  {selectedLocation.phoneNumber}
                </a>
              </p>
            )}
            {selectedLocation.websiteUrl && (
              <a
                target="_blank"
                href={selectedLocation.websiteUrl}
                rel="noreferrer"
                className={styles.websiteLink}>
                Visit Website
              </a>
            )}
          </div>
        </InfoWindow>
      )}
    </GoogleMap>
  );
};
